const subdomains = [
  'amityage',
  'cryptohall24-quetta',
  'cryptohall24-duerr',
  'qurubiqa',
  'bitcluster',
  'paymine',
  'dahab',
  'bmw',
  'stellar-forge',
  'pantheon',
  'pantheon-aus',
  'avatron',
  'polarcore',
  'endlessmining',
  'sabre56',
  'chronos-energy',
  'higgs',
  'mawson',
  'revolve-labs',
  'hearst',
  'datacubes',
  'bitasics',
  'emcd',
  'blueforge',
  'cryptotech',
  'miningstore',
  'hashlabs',
  'corpa',
  'terahash',
  'fortris',
  'ymir',
  'chazon',
  'miningwithbrad',
];

const extractSubdomain = () => {
  const hostnameParts = window.location.hostname.split('.');

  const matchedSubdomain = hostnameParts.find(part => subdomains.includes(part));

  return {
    matchedSubdomain,
    hostnameParts,
  };
};

export const getDomainAndSubdomain = () => {
  const { matchedSubdomain, hostnameParts } = extractSubdomain();

  const domainParts = hostnameParts.filter(p => p !== matchedSubdomain);
  const domain = domainParts.join('.');

  return {
    subdomain: matchedSubdomain ?? 'my',
    domain,
  };
};

export const setMetaData = (subdomain: string, override?: { favicon?: string; title?: string }) => {
  const metaConfig: Record<string, { favicon: string; title: string }> = {
    amityage: {
      favicon: '/amityAge.ico',
      title: 'Amityage',
    },
    'cryptohall24-duerr': {
      favicon: '/cryptohall24.ico',
      title: 'Cryptohall24 Duerr',
    },
    'cryptohall24-quetta': {
      favicon: '/cryptohall24.ico',
      title: 'Cryptohall24 Quetta',
    },
    qurubiqa: {
      favicon: '/qurubiqa.ico',
      title: 'Qurubiqa',
    },
    bitcluster: {
      favicon: '/bitcluster.ico',
      title: 'Bitcluster',
    },
    paymine: {
      favicon: '/paymine.ico',
      title: 'Paymine',
    },
    dahab: {
      favicon: '/dahab.ico',
      title: 'Dahab Miners',
    },
    bmw: {
      favicon: '/bmw.ico',
      title: 'Bitcoin Mining World',
    },
    'stellar-forge': {
      favicon: '/stellar-forge.ico',
      title: 'Stellar Forge Mining',
    },
    pantheon: {
      favicon: '/pantheon.ico',
      title: 'Pantheon Mining',
    },
    'pantheon-aus': {
      favicon: '/pantheon.ico',
      title: 'Pantheon-AUS Mining',
    },
    avatron: {
      favicon: '/avatron.ico',
      title: 'Avatron Mining',
    },
    polarcore: {
      favicon: '/polarcore.ico',
      title: 'Polarcore',
    },
    endlessmining: {
      favicon: '/endlessmining.ico',
      title: 'Endless Mining',
    },
    sabre56: {
      favicon: '/sabre56.ico',
      title: 'Sabre56',
    },
    'chronos-energy': {
      favicon: '/chronos-energy.ico',
      title: 'Chronos Energy',
    },
    higgs: {
      favicon: '/higgs.ico',
      title: 'Higgs',
    },
    mawson: {
      favicon: '/mawson.ico',
      title: 'Mawson',
    },
    'revolve-labs': {
      favicon: '/revolve-labs.svg',
      title: 'Revolve Labs',
    },
    hearst: {
      favicon: '/hearst.ico',
      title: 'Hearst',
    },
    datacubes: {
      favicon: '/datacubes.ico',
      title: 'Datacubes',
    },
    bitasics: {
      favicon: '/bitasics.ico',
      title: 'Bitasics',
    },
    emcd: {
      favicon: '/emcd.svg',
      title: 'EMCD',
    },
    blueforge: {
      favicon: '/blueforge.ico',
      title: 'BlueForge',
    },
    cryptotech: {
      favicon: '/cryptotech.svg',
      title: 'CryptoTech',
    },
    miningstore: {
      favicon: '/miningstore.ico',
      title: 'MiningStore',
    },
    hashlabs: {
      favicon: '/hashlabs.ico',
      title: 'Hashlabs',
    },
    corpa: {
      favicon: '/corpa.ico',
      title: 'CorPa',
    },
    terahash: {
      favicon: '/terahash.ico',
      title: 'Terahash',
    },
    fortris: {
      favicon: '/fortris.svg',
      title: 'Fortris',
    },
    ymir: {
      favicon: '/ymir.png',
      title: 'Ymir',
    },
    chazon: {
      favicon: '/chazon.ico',
      title: 'Chazon Mining',
    },
    miningwithbrad: {
      favicon: '/duckEnergy.ico',
      title: 'MiningWithBrad',
    },
  };

  const fallback = metaConfig[subdomain] ?? {
    favicon: '/duckEnergy.ico',
    title: 'DuckEnergy',
  };
  const favicon = override?.favicon ?? fallback.favicon;
  const title = override?.title ?? fallback.title;

  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    document.head.appendChild(link);
  }

  link.href = favicon;

  const titleEl = document.querySelector('title') as HTMLTitleElement;
  if (titleEl) {
    titleEl.textContent = title;
  }
};
